/* momomoca — PDP behavior: gallery, variant selection, sticky ATC */
(function () {
  'use strict';
  var root = document.querySelector('[data-product-json]');
  if (!root) return;

  var product = JSON.parse(root.dataset.productJson);
  var variantIdInput = root.querySelector('[data-variant-id]');
  var priceEl = root.querySelector('[data-product-price]');
  var unitPrice = priceEl ? parseInt(priceEl.dataset.unitPrice || '0', 10) : 0;
  var atcButton = root.querySelector('[data-atc-button]');
  var optionGroups = root.querySelectorAll('select[data-option-index]');
  var selected = {};

  /* Seed `selected` from the currently chosen variant */
  var currentVariant = product.variants.find(function (v) { return v.id.toString() === variantIdInput.value; }) || product.variants[0];
  (currentVariant.options || []).forEach(function (val, i) { selected[i] = val; });

  function findVariant(sel) {
    return product.variants.find(function (v) {
      return (v.options || []).every(function (val, i) { return sel[i] === val; });
    });
  }

  /* Quantity x price. The headline price stays per-item; the multiplied figure
     is shown separately and only when quantity is 2 or more, so nobody reads it
     as the item's price having changed. */
  function renderTotals() {
    var qtyField = root.querySelector('[data-pdp-qty-input]');
    var qty = Math.max(1, parseInt((qtyField && qtyField.value) || '1', 10) || 1);

    var lineTotal = root.querySelector('[data-line-total]');
    if (lineTotal) {
      lineTotal.hidden = qty < 2;
      if (qty >= 2) lineTotal.textContent = 'Total ' + formatMoney(unitPrice * qty);
    }

    /* the stepper sits next to this in the sticky bar, so the quantity is
       already on screen -- the figure alone reads fine */
    var stickyPrice = document.querySelector('[data-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = formatMoney(unitPrice * qty);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateUI(variant) {
    if (!variant) return;
    variantIdInput.value = variant.id;

    if (priceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.innerHTML =
          '<span class="product-page__price-sale">' + formatMoney(variant.price) + '</span>' +
          '<span class="product-page__price-compare">' + formatMoney(variant.compare_at_price) + '</span>';
      } else {
        priceEl.innerHTML = '<span>' + formatMoney(variant.price) + '</span>';
      }
    }

    if (atcButton) {
      atcButton.disabled = !variant.available;
      atcButton.textContent = variant.available
        ? (window.momomocaStrings.addToCart || 'Add to Cart')
        : (window.momomocaStrings.soldOut || 'Sold Out');
    }

    unitPrice = variant.price;
    renderTotals();

    /* the sticky bar has its own button, so it needs the same sold-out state --
       otherwise a sold-out variant still shows a live "Add to Cart" down there */
    var stickyAtc = document.querySelector('[data-sticky-atc-button]');
    if (stickyAtc) {
      stickyAtc.disabled = !variant.available;
      stickyAtc.textContent = variant.available
        ? (window.momomocaStrings.addToCart || 'Add to Cart')
        : (window.momomocaStrings.soldOut || 'Sold Out');
    }

    /* Swap gallery image if this variant has a dedicated featured image */
    if (variant.featured_media) {
      var slide = document.querySelector('[data-slide][data-media-id="' + variant.featured_media.id + '"]');
      if (slide) activateSlide(variant.featured_media.id);
    }
  }

  optionGroups.forEach(function (sel) {
    var index = parseInt(sel.dataset.optionIndex, 10);
    sel.addEventListener('change', function () {
      selected[index] = sel.value;
      updateUI(findVariant(selected));
    });
  });

  /* ---------------- Gallery ---------------- */
  function activateSlide(mediaId) {
    document.querySelectorAll('[data-slide]').forEach(function (s) {
      s.classList.toggle('hidden', s.dataset.mediaId !== mediaId.toString());
    });
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t.dataset.mediaId === mediaId.toString());
    });
  }
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () { activateSlide(thumb.dataset.mediaId); });
  });

  /* ---------------- Gallery arrows ---------------- */
  (function () {
    var slides = Array.prototype.slice.call(document.querySelectorAll('[data-slide]'));
    var prev = document.querySelector('[data-gallery-prev]');
    var next = document.querySelector('[data-gallery-next]');
    if (!slides.length || !prev || !next) return;

    if (slides.length < 2) {            // single image: nothing to page through
      prev.hidden = true;
      next.hidden = true;
      return;
    }

    var counter = document.querySelector('[data-gallery-counter] b');
    function syncCounter() {
      if (counter) counter.textContent = String(currentIndex() + 1);
    }
    function currentIndex() {
      for (var i = 0; i < slides.length; i++) {
        if (!slides[i].classList.contains('hidden')) return i;
      }
      return 0;
    }
    function step(delta) {
      var i = (currentIndex() + delta + slides.length) % slides.length;
      activateSlide(slides[i].dataset.mediaId);
      syncCounter();
      var thumb = document.querySelector('[data-thumb][data-media-id="' + slides[i].dataset.mediaId + '"]');
      if (thumb && thumb.scrollIntoView) {
        thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });

    // 썸네일 클릭으로 바뀌는 경우까지 잡으려면 슬라이드 상태를 관찰해야 한다
    var main0 = document.querySelector('[data-gallery-main]');
    if (main0 && window.MutationObserver) {
      new MutationObserver(syncCounter).observe(main0, {
        subtree: true, attributes: true, attributeFilter: ['class']
      });
    }
    syncCounter();

    // swipe on touch
    var startX = null;
    var main = document.querySelector('[data-gallery-main]');
    main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 45) step(dx < 0 ? 1 : -1);
      startX = null;
    }, { passive: true });
  })();

  /* ---------------- Quantity stepper ---------------- */
  var qtyInput = root.querySelector('[data-pdp-qty-input]');
  var incBtn = root.querySelector('[data-pdp-qty-increase]');
  var decBtn = root.querySelector('[data-pdp-qty-decrease]');
  if (incBtn) incBtn.addEventListener('click', function () { qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) + 1); renderTotals(); });
  if (decBtn) decBtn.addEventListener('click', function () { qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1); renderTotals(); });
  if (qtyInput) qtyInput.addEventListener('input', renderTotals);

  /* ---------------- Sticky mobile ATC bar ---------------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var stickyBtn = document.querySelector('[data-sticky-atc-button]');
  var formButton = root.querySelector('[data-atc-button]');
  if (stickyBar && formButton) {
    var observer = new IntersectionObserver(function (entries) {
      stickyBar.hidden = entries[0].isIntersecting;
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    observer.observe(formButton);

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        root.querySelector('#ProductForm').requestSubmit();
      });
    }

    /* Sticky quantity. #ProductQty is the field that actually submits, so the
       sticky stepper writes into it and both displays are kept in step -- a
       shopper who sets 2 up top must not send 1 from down here. */
    var sQty = stickyBar.querySelector('[data-sticky-qty-input]');
    if (sQty && qtyInput) {
      var setQty = function (n) {
        var v = Math.max(1, n || 1);
        qtyInput.value = v;
        sQty.value = v;
        renderTotals();
      };
      stickyBar.querySelector('[data-sticky-qty-increase]').addEventListener('click', function () {
        setQty(parseInt(qtyInput.value || '1', 10) + 1);
      });
      stickyBar.querySelector('[data-sticky-qty-decrease]').addEventListener('click', function () {
        setQty(parseInt(qtyInput.value || '1', 10) - 1);
      });
      sQty.addEventListener('change', function () { setQty(parseInt(sQty.value, 10)); });
      qtyInput.addEventListener('change', function () { setQty(parseInt(qtyInput.value, 10)); });
      /* mirror the main stepper's buttons too */
      if (incBtn) incBtn.addEventListener('click', function () { sQty.value = qtyInput.value; });
      if (decBtn) decBtn.addEventListener('click', function () { sQty.value = qtyInput.value; });
      renderTotals();
    }
  }
})();
